module.exports = __webpack_public_path__ + "img/cp2.8d7ed15c.png";